import SidebarMobileBurger from "@/components/SidebarMobileBurger/SidebarMobileBurger.vue";
import SidebarMobileMenu from "@/components/SidebarMobileMenu/SidebarMobileMenu.vue";
import {mapActions, mapGetters} from "vuex";
import BlurBackground from "@/components/__new_ui_kit/BlurBackground/BlurBackground";

export default {
    name: "MobileMenu",
    data() {
        return {
        }
    },
    components: {SidebarMobileBurger, SidebarMobileMenu, BlurBackground},
    methods: {
        ...mapActions(['toggleMobileMenu']),
    },
    computed: {
        ...mapGetters(['getMenuStatus'])
    }

}